import CheckmateApiClient from '../../../../services/apiClient';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export const useGetNotes = (noteTypeId: number) => {
    return useQuery({
        queryKey: ['get-notes', noteTypeId],
        queryFn: async () => {
            const response = await _apiClient.getNotes(noteTypeId);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve notes.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        cacheTime: 0,
        staleTime: 0,
    });
};
